import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flexRow pb-5" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "control-label" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "control-label" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "control-label" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "control-label" }
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = { class: "pull-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_product_appuntamento = _resolveComponent("product-appuntamento")!
  const _component_product_course = _resolveComponent("product-course")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary float-right",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Salva",
          text: "Salva"
        })
      ]),
      _createElementVNode("h4", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Dettaglio prodotto",
          text: "Dettaglio prodotto"
        })
      ]),
      _hoisted_3,
      (_ctx.product)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Nome",
                  text: "Nome"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.product.nome) = $event))
              }, null, 512), [
                [_vModelText, _ctx.product.nome]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Sottotitolo",
                  text: "Sottotitolo"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.product.subTitle) = $event))
              }, null, 512), [
                [_vModelText, _ctx.product.subTitle]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Display Order",
                  text: "Display Order"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "number",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.product.displayOrder) = $event))
              }, null, 512), [
                [_vModelText, _ctx.product.displayOrder]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Tipo prodotto",
                  text: "Tipo prodotto"
                })
              ]),
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.product.productType) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productTypes, (item, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: item,
                    key: i
                  }, _toDisplayString(item), 9, _hoisted_13))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.product.productType]
              ])
            ]),
            (_ctx.product && _ctx.product.productType == 'appuntamento')
              ? (_openBlock(), _createBlock(_component_product_appuntamento, {
                  key: 0,
                  product: _ctx.product
                }, null, 8, ["product"]))
              : _createCommentVNode("", true),
            (_ctx.product && _ctx.product.productType == 'corso')
              ? (_openBlock(), _createBlock(_component_product_course, {
                  key: 1,
                  product: _ctx.product
                }, null, 8, ["product"]))
              : _createCommentVNode("", true),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Salva",
                  text: "Salva"
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}